module.exports = __webpack_public_path__ + "static/media/chicken.4f970db0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chicken.png
// module id = 34
// module chunks = 0